import { post } from "../core/request";

/**
 * 字典项数据
 */
const DICT_ITEM_DATA = {};

export function getDictItemList(param) {
  // 初始化缓存
  if (typeof getDictItemList._hook === "undefined") {
    getDictItemList._hook = {};
  }
  const _hook = getDictItemList._hook;
  return new Promise((resolve, reject) => {
    const { dictCode } = param;
    if (DICT_ITEM_DATA[dictCode]) {
      // 命中缓存
      resolve(DICT_ITEM_DATA[dictCode]);
      return;
    }
    // 初始化 Hook
    let initHook = false;
    let keyHook = _hook[dictCode];
    if (!keyHook || !keyHook.length) {
      initHook = true;
      keyHook = _hook[dictCode] = [];
    }
    // 注册 Hook 函数
    keyHook.push({resolve, reject});
    if (!initHook) {
      return;
    }
    // 获取数据
    getDict({ dictCode }).then(res => {
      const { data } = res;
      DICT_ITEM_DATA[dictCode] = data;
      // 回调 Hook 函数
      while (keyHook.length) {
        keyHook.pop().resolve(data);
      }
    }).catch(res => {
      // 回调 Hook 函数
      while (keyHook.length) {
        keyHook.pop().reject();
      }
    });
  });
}

function getDict(data) {
  return post({
    url: "/api/ums/sysDictItem/getDict",
    data,
  });
}

export function getDictItem(param) {
  return new Promise((resolve, reject) => {
    const { dictCode } = param;
    getDict({ dictCode }).then(items => {
      const { value } = param;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (String(value) === item.value) {
          resolve(item);
          return;
        }
      }
      reject();
    }).catch(() => {
      reject();
    });
  });
}

export function getLabel(param) {
  return new Promise((resolve, reject) => {
    const { dictCode, value } = param;
    getDictItem({ dictCode, value }).then(item => {
      resolve(item.label);
    }).catch(() => {
      reject();
    });
  });
}
